import { combineReducers } from '@ngrx/store';
import { questionnaireGroupsReducer } from './questionnaire-groups.reducer';

export const CONFIGURABLE_QUESTIONNAIRES_FEATURE_KEY = 'configurableQuestionnaires';

export const configurableQuestionnairesReducer = combineReducers({
    questionnaireGroups: questionnaireGroupsReducer,
});

export * from './questionnaire-groups.reducer';

